import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { WrestlerSeedingCriteria } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';

/**
 * Service to get and save a wrestling seeding criteria.
 */
@Injectable()
export class WrestlerSeedingCriteriaService {
    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Get all the seeding criteria for a given event and division
     */
    public getIndex(eventId: string, wrestlerId: string): Observable<WrestlerSeedingCriteria[]> {
        const apiRequestUrl: string = this.getApiUrl(eventId, wrestlerId);

        return this.http.get(apiRequestUrl)
            .pipe(map((response: IJsonApiResponse) => {
                const wrestlerSeedingCriteriaList: WrestlerSeedingCriteria[] = [];
                const included: any[] = response.included;
                const bodyData: any = response.data || [];
                for (const wrestlerSeedingCriteria of bodyData) {
                    wrestlerSeedingCriteriaList.push((new WrestlerSeedingCriteria())
                        .deserialize(wrestlerSeedingCriteria, included));
                }
                return wrestlerSeedingCriteriaList;
            }));
    }

    /**
     * Add or update a seeding criteria
     */
    public save(wrestlerSeedingCriteria: WrestlerSeedingCriteria): Observable<WrestlerSeedingCriteria> {
        const eventId: string = wrestlerSeedingCriteria.eventId;
        const wrestlerId: string = wrestlerSeedingCriteria.wrestlerId;
        let response: Observable<IJsonApiResponse>;

        if (wrestlerSeedingCriteria.id) {
            // Update existing Division
            const apiRequestUrl: string = this.getApiUrl(eventId, wrestlerId) + wrestlerSeedingCriteria.id;
            response = this.http.patch(apiRequestUrl, wrestlerSeedingCriteria.serialize());
        } else {
            // Add a new Division
            const apiRequestUrl: string = this.getApiUrl(eventId, wrestlerId);
            response = this.http.post(apiRequestUrl, wrestlerSeedingCriteria.serialize());
        }

        return response
            .pipe(map((response: IJsonApiResponse) => (new WrestlerSeedingCriteria()).deserialize(response)));
    }

    /**
     * Delete a seeding criteria. This service will fail if a wrestler is linked the seeding criteria to be removed.
     */
    public delete(eventId: string, wrestlerId: string, wrestlerSeedingCriteriaId: string): Observable<boolean> {
        const apiRequestUrl: string = this.getApiUrl(eventId, wrestlerId) + wrestlerSeedingCriteriaId;
        return this.http.delete(apiRequestUrl).pipe(map((response: IJsonApiResponse) => true));
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(eventId: string, wrestlerId: string): string {
        return `${this.http.configService.getApiBaseUrl()}/events/${eventId}/wrestlers/${wrestlerId}/seeding-criteria/`;
    }
}
